var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insure-write-container__form",class:{ 'need-fixed-width': _vm.needFixedWidth }},[_c('form-create',{attrs:{"rule":_vm.rule,"option":_vm.options},on:{"change":_vm.changeHandle},model:{value:(_vm.fApi),callback:function ($$v) {_vm.fApi=$$v},expression:"fApi"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }